/* unplugin-vue-components disabled */import { render } from "./TermsAndCondition.vue?vue&type=template&id=f5d14310"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__